import { validateBr } from 'js-brasil'

export function validateCNH(cnh: string): boolean {
  return validateBr.cnh(cnh)
}
